import dayjs from "dayjs";

export function getUpdatedVideoState({ state, result }) {
    let newState = { ...state };
    if (state.artistResult && state.artistResult.coverVideo) {
        newState.artistResult.coverVideo = result.coverVideo;
    }
    return newState;
}

export function getUpdatedTrackState({ state, result }) {
    let newState = { ...state };
    if (state.artistResult && state.artistResult.track) {
        newState.artistResult.track.forEach(track => {
            if (result.track.id === track.id)
                track.status = result.track.status;
        });
    }
    return newState;
}

export function getUpdatedArtistState({ state, result, key }) {
    let newState = { ...state };
    if (state.artistResult && typeof state.artistResult === "object") {
        newState.artistResult[key] = result;
    }
    return newState;
}

export function normailezeHeavyRotationResult(result) {
    const { list, count } = result;

    const normalizedList = list.map(elem => {
        const normalizedElem = {};
        ["id", "name", "active", "period"].map(
            key => (normalizedElem[key] = elem[key])
        );

        const { heavyRotationStartDate, heavyRotationEndDate } = elem;

        if (heavyRotationEndDate && heavyRotationStartDate) {
            normalizedElem.datesForHeavyRotation = `
            ${dayjs(heavyRotationStartDate).format("DD/MM/YY")} -
            ${dayjs(heavyRotationEndDate).format("DD/MM/YY")}`;
        } else {
            normalizedElem.datesForHeavyRotation = "-";
        }

        return normalizedElem;
    });

    return { list: normalizedList, count };
}

export function getPathForHeavyRotation(data) {
    const { offset, limit, name, id, active } = data;

    let path = `/artists?limit=${Number.parseInt(
        limit
    )}&offset=${Number.parseInt(offset)}`;
    if (id) {
        path += `&id=${id}`;
    }
    if (name) {
        path += `&name=${name}`;
    }
    if (active !== "Not set" && active !== null) {
        path += `&active=${active}`;
        path += `&visible=${active}`;
    }
    return path;
}

export function getPathForDJUserList(data) {
    const {
        offset,
        limit,
        id,
        email,
        username,
        djName,
        loginid,
        migId,
        authEmail,
        paypalEmail,
        billingName,
        billingAddress,
        authSubId,
        paypalSubId
    } = data;

    let path = `/admins/getDJList/?limit=${Number.parseInt(
        limit
    )}&offset=${Number.parseInt(offset)}`;
    if (id) {
        path += `&id=${id}`;
    }
    if (username) {
        path += `&username=${username}`;
    }
    if (email) {
        path += `&email=${email}`;
    }
    if (loginid) {
        path += `&loginid=${loginid}`;
    }
    if (djName) {
        path += `&djName=${djName}`;
    }
    if (migId) {
        path += `&migId=${migId}`;
    }
    if (authEmail) {
        path += `&authEmail=${authEmail}`;
    }
    if (paypalEmail) {
        path += `&paypalEmail=${paypalEmail}`;
    }
    if (billingName) {
        path += `&billingName=${billingName}`;
    }
    if (billingAddress) {
        path += `&billingAddress=${billingAddress}`;
    }
    if (authSubId) {
        path += `&authSubId=${authSubId}`;
    }
    if (paypalSubId) {
        path += `&paypalSubId=${paypalSubId}`;
    }

    return path;
}

export function getInvalidUsersListPath(data) {
    const { offset, limit } = data;

    let path = `/admins/invalidusers/?limit=${Number.parseInt(
        limit
    )}&offset=${Number.parseInt(offset)}`;

    return path;
}

export function getReturningMembersListPath(data) {
    const { offset, limit, id, email, login, offerStatus } = data || {};

    let path = `/admins/returningMembers?limit=${Number.parseInt(
        limit
    )}&offset=${Number.parseInt(offset)}`;
    const status = offerStatus || "all";
    path += `&offerStatus=${encodeURIComponent(status)}`;
    if (id) {
        path += `&id=${encodeURIComponent(id)}`;
    }
    if (email) {
        path += `&email=${encodeURIComponent(email)}`;
    }
    if (login) {
        path += `&login=${encodeURIComponent(login)}`;
    }

    return path;
}

function formatYesNo(value) {
    if (value === true || value === 1 || value === "1" || value === "true") {
        return "Yes";
    }
    if (value === false || value === 0 || value === "0" || value === "false") {
        return "No";
    }
    return "-";
}

function formatOptionalDate(value) {
    if (!value) return "-";
    return dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD HH:mm") : String(value);
}

export function normalizeReturningMembersResult(result) {
    const list = (result.list || []).map(member => ({
        ...member,
        lastExpiredDate: member.lastExpiredDate
            ? dayjs(member.lastExpiredDate).format("YYYY-MM-DD")
            : "-",
        offerSent: formatYesNo(member.offerSent),
        hasActiveOffer: formatYesNo(member.hasActiveOffer),
        lastOfferSentAt: formatOptionalDate(member.lastOfferSentAt),
        lastSentToEmail: member.lastSentToEmail || "-"
    }));
    return { list, count: result.count || 0 };
}

export const DEFAULT_OFFER_DURATION_DAYS = 30;
export const DEFAULT_BATCH_SIZE = 50;
export const OFFER_DURATION_DAYS_MIN = 1;
export const OFFER_DURATION_DAYS_MAX = 365;
export const BATCH_SIZE_MIN = 1;
export const BATCH_SIZE_MAX = 500;

function clampInt(value, min, max, fallback) {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed)) return fallback;
    if (parsed < min || parsed > max) return fallback;
    return parsed;
}

export function normalizeReturningMemberSettings(result) {
    const source = result && typeof result === "object" ? result : {};
    const rawDays =
        source.offerDurationDays != null
            ? source.offerDurationDays
            : source.offerLinkValidityDays != null
            ? source.offerLinkValidityDays
            : source.validityDays != null
            ? source.validityDays
            : source.linkValidityDays != null
            ? source.linkValidityDays
            : source.days;
    const rawBatch =
        source.batchSize != null ? source.batchSize : source.batch_size;

    return {
        offerDurationDays: clampInt(
            rawDays,
            OFFER_DURATION_DAYS_MIN,
            OFFER_DURATION_DAYS_MAX,
            DEFAULT_OFFER_DURATION_DAYS
        ),
        batchSize: clampInt(
            rawBatch,
            BATCH_SIZE_MIN,
            BATCH_SIZE_MAX,
            DEFAULT_BATCH_SIZE
        )
    };
}

export function normalizeReturningMemberCampaignStatus(result) {
    const payload = unwrapCampaignStatusPayload(result);
    const queue =
        payload.queue && typeof payload.queue === "object"
            ? payload.queue
            : payload;
    const totals =
        payload.totals && typeof payload.totals === "object"
            ? payload.totals
            : payload.counts && typeof payload.counts === "object"
            ? payload.counts
            : {};
    const toCount = (...values) => {
        for (let i = 0; i < values.length; i += 1) {
            if (values[i] == null || values[i] === "") continue;
            const parsed = Number.parseInt(values[i], 10);
            if (Number.isFinite(parsed)) return parsed;
        }
        return 0;
    };
    const rawStatus =
        payload.campaignStatus ||
        payload.campaign_status ||
        payload.state ||
        payload.status ||
        "";
    const ignoredStatus = ["success", "error", "ok", "fail"].includes(
        String(rawStatus).toLowerCase()
    );
    const inProgress =
        payload.inProgress === true ||
        payload.in_progress === true ||
        payload.isRunning === true;
    let status = ignoredStatus
        ? payload.campaignStatus ||
          payload.campaign_status ||
          payload.state ||
          (inProgress ? "running" : "")
        : rawStatus || (inProgress ? "running" : "");

    const totalQueued = toCount(
        payload.totalQueued,
        payload.total_queued,
        payload.queuedCount,
        payload.queueSize,
        totals.totalQueued,
        totals.queued,
        queue.totalQueued,
        queue.total,
        payload.queued
    );
    const totalFailed = toCount(
        payload.totalFailed,
        payload.total_failed,
        payload.failed,
        payload.failedCount,
        totals.totalFailed,
        totals.failed,
        queue.totalFailed,
        queue.failed
    );
    const totalSkipped = toCount(
        payload.totalSkipped,
        payload.total_skipped,
        payload.skipped,
        payload.skippedCount,
        totals.totalSkipped,
        totals.skipped
    );
    const totalPending = toCount(
        payload.totalPending,
        payload.total_pending,
        payload.pending,
        payload.pendingCount,
        payload.remaining,
        totals.totalPending,
        totals.pending,
        queue.totalPending,
        queue.pending
    );
    let totalSent = toCount(
        payload.totalSent,
        payload.total_sent,
        payload.sent,
        payload.sentCount,
        payload.emailsSent,
        payload.successCount,
        payload.succeeded,
        payload.delivered,
        totals.totalSent,
        totals.sent,
        queue.totalSent,
        queue.sent
    );
    const derivedSent = Math.max(0, totalQueued - totalPending - totalFailed);
    if (totalSent === 0 && derivedSent > 0) {
        totalSent = derivedSent;
    }

    const statusLower = String(status).toLowerCase();
    const stoppedStatuses = ["cancelled", "canceled", "failed"];
    const finishedStatuses = [
        ...stoppedStatuses,
        "completed",
        "complete",
        "done",
        "finished"
    ];
    const emailsStillQueued =
        totalPending > 0 ||
        (totalQueued > 0 && totalSent + totalFailed < totalQueued);
    const workFinished =
        totalQueued > 0 &&
        totalPending === 0 &&
        totalSent + totalFailed >= totalQueued;
    if (emailsStillQueued && !stoppedStatuses.includes(statusLower)) {
        status = "running";
    } else if (workFinished && !finishedStatuses.includes(statusLower)) {
        status = "completed";
    }

    return {
        status: status || (inProgress ? "running" : "idle"),
        totalQueued,
        totalSent,
        totalFailed,
        totalSkipped,
        totalPending,
        message: payload.message || (result && result.message) || ""
    };
}

export function mergeCampaignStatus(previous, next) {
    if (!next) return previous || next;
    const nextEmpty =
        !next.totalQueued &&
        !next.totalSent &&
        !next.totalFailed &&
        !next.totalPending;
    const nextIdle = ["idle", "", "none"].includes(
        String(next.status || "").toLowerCase()
    );
    if (previous && previous.totalQueued > 0 && nextEmpty && nextIdle) {
        const sent =
            previous.totalSent ||
            Math.max(0, previous.totalQueued - (previous.totalFailed || 0));
        return {
            ...previous,
            status: isReturningMemberCampaignActive(previous)
                ? "completed"
                : previous.status,
            totalPending: 0,
            totalSent: sent
        };
    }
    return next;
}

export function formatCampaignStatusLabel(status) {
    const value = String(status || "").trim();
    if (!value) return "-";
    return value.charAt(0).toUpperCase() + value.slice(1);
}

function unwrapCampaignStatusPayload(result) {
    if (!result || typeof result !== "object") return {};
    const source =
        result.result && typeof result.result === "object" && !Array.isArray(result.result)
            ? result.result
            : result;
    const active =
        source.activeCampaign && typeof source.activeCampaign === "object"
            ? source.activeCampaign
            : null;
    const lastCompleted =
        source.lastCompletedCampaign &&
        typeof source.lastCompletedCampaign === "object"
            ? source.lastCompletedCampaign
            : source.lastCampaign && typeof source.lastCampaign === "object"
            ? source.lastCampaign
            : null;

    if (active) {
        return {
            ...source,
            ...active,
            totalPending:
                active.totalPending != null
                    ? active.totalPending
                    : source.totalPending,
            totalFailed:
                active.totalFailed != null
                    ? active.totalFailed
                    : source.totalFailed,
            totalSkipped:
                active.totalSkipped != null
                    ? active.totalSkipped
                    : source.totalSkipped
        };
    }
    if (lastCompleted) {
        return {
            ...lastCompleted,
            totalPending:
                lastCompleted.totalPending != null
                    ? lastCompleted.totalPending
                    : 0
        };
    }

    const nestedCandidates = [
        source.campaign,
        source.data,
        source.payload,
        source.stats,
        source.totals,
        source.progress
    ];
    for (let i = 0; i < nestedCandidates.length; i += 1) {
        const candidate = nestedCandidates[i];
        if (candidate && typeof candidate === "object" && !Array.isArray(candidate)) {
            return candidate;
        }
    }
    return source;
}

export function isReturningMemberCampaignActive(statusResult) {
    if (!statusResult) return false;
    const queued = Number(statusResult.totalQueued) || 0;
    const pending = Number(statusResult.totalPending) || 0;
    const sent = Number(statusResult.totalSent) || 0;
    const failed = Number(statusResult.totalFailed) || 0;
    const done = sent + failed;
    if (queued > 0 && pending === 0 && done >= queued) {
        return false;
    }
    if (queued > 0 && pending === 0 && done > 0) {
        return false;
    }
    const status = String(statusResult.status || "").toLowerCase();
    if (
        status === "idle" ||
        status === "completed" ||
        status === "complete" ||
        status === "cancelled" ||
        status === "canceled" ||
        status === "done" ||
        status === "finished" ||
        status === "failed"
    ) {
        return pending > 0;
    }
    const activeStatuses = [
        "queued",
        "queueing",
        "queuing",
        "running",
        "processing",
        "in_progress",
        "in-progress",
        "pending",
        "started",
        "starting",
        "sending",
        "active"
    ];
    if (activeStatuses.includes(status)) return true;
    return pending > 0;
}

export function getApiErrorMessage(error, fallback = "Request failed.") {
    if (!error) return fallback;
    const direct = String(error.message || "").trim();
    if (direct) return direct;

    const details = error.details || {};
    const common = details.common;
    if (typeof common === "string" && common.trim()) {
        return common.trim();
    }
    if (common && typeof common === "object") {
        const fromCommon = common.kind || common.label || common.message;
        if (fromCommon && String(fromCommon).trim()) {
            return String(fromCommon).trim();
        }
    }

    const firstDetail = Object.keys(details)
        .map(key => details[key])
        .find(Boolean);
    if (typeof firstDetail === "string" && firstDetail.trim()) {
        return firstDetail.trim();
    }
    if (firstDetail && typeof firstDetail === "object") {
        const fromDetail =
            firstDetail.kind || firstDetail.label || firstDetail.message;
        if (fromDetail && String(fromDetail).trim()) {
            return String(fromDetail).trim();
        }
    }

    return fallback;
}

export function normalizeReturningMemberOfferResult(result) {
    if (!result || typeof result !== "object") {
        return { message: "Offer sent successfully." };
    }
    const offerLink =
        result.offerLink || result.link || result.url || result.offerUrl || null;
    const expiresAt =
        result.expiresAt ||
        result.expiry ||
        result.validUntil ||
        result.offerExpiresAt ||
        null;
    return {
        ...result,
        message: result.message || "Offer sent successfully.",
        offerLink,
        expiresAt: expiresAt
            ? dayjs(expiresAt).isValid()
                ? dayjs(expiresAt).format("YYYY-MM-DD HH:mm")
                : String(expiresAt)
            : null
    };
}

export function getPathForDJUserDetails(id) {
    let path = `/admins/getDJList/?id=${id}`;
    return path;
}

export function normalizeDJUserDetailsResult(result) {
    Object.keys(result.list[0]).map(e => {
        if (result.list[0][e] === null) {
            result.list[0][e] = "";
        }
        return result.list[0][e];
    });
    return {
        ...result.list[0],
        active: result.list[0]["allow_user"],
        password: ""
    };
}

export function normalizeDJUserListResult(result) {
    return { list: result.list.map(normalizeUser), count: result.count };
}

// export function normalizeInvalidUsersListResult(result) {
//     return { list: result.list.map(normalizeUser), count: result.count };
// }

export function getPathForDJUserTransHistory(data) {
    const {
        offset,
        limit,
        id,
        transactionId,
        type,
        startDate,
        endDate,
        transactionStatus,
        invoiceNumber,
        lastFourCardDigit,
        amount,
        subscriptionId,
        userId
    } = data;

    let path = `/admins/getDJTransHistory/?limit=${Number.parseInt(
        limit
    )}&offset=${Number.parseInt(offset)}`;
    if (id) {
        path += `&id=${id}`;
    }
    if (userId) {
        path += `&userId=${userId}`;
    }
    if (startDate) {
        path += `&startDate=${startDate}`;
    }
    if (endDate) {
        path += `&endDate=${endDate}`;
    }

    return path;
}

export function normalizeDJUserTransHistoryResult(result) {
    const filteredResult =
        result.list &&
        result.list.map(elem => {
            return {
                ...elem,
                submitDate: dayjs(elem.submitDate).format(
                    "YYYY-MM-DD hh:mm:ss"
                )
            };
        });
    return { list: filteredResult, count: result.count };
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function normalizeUser(user) {
    const {
        email,
        fullName,
        login,
        baseUserId,
        djName,
        allow_user,
        phone,
        date_added,
        payment_type
    } = user;

    return {
        id: baseUserId,
        email,
        fullName,
        login,
        djName,
        allow_user,
        phone,
        date_added,
        payment_type
    };
}
